import React from 'react';
import MaterialCard from './MaterialCard';
import './SearchResults.css';

const SearchResults = ({ searchQuery, searchResults, onToggleFavorite, appData }) => {
  return (
    <div className="search-results">
      {searchResults.length > 0 ? (
        <>
          <div className="section-header">
            <h2>Результаты поиска ({searchResults.length})</h2>
          </div>
          <div className="materials-grid">
            {searchResults.map(material => (
              <MaterialCard
                key={material.uniqueKey}
                material={material}
                onToggleFavorite={onToggleFavorite}
                appData={appData}
              />
            ))}
          </div>
        </>
      ) : (
        <div className="no-search-results">
          <p>По запросу "{searchQuery}" ничего не найдено</p>
          <p>Попробуйте изменить поисковый запрос</p>
        </div>
      )}
    </div>
  );
};

export default SearchResults; 